import { useBreakpoints } from "@narmi/design_system";

import AccountBalances from "../../../../components/dashboard/AccountBalances";
import styles from "../AccountsModule.module.scss";
import AccountCard from "../AccountCard";
import AccountListRow from "../AccountListRow";
import EmptyAccountBalances from "../../../../components/dashboard/EmptyAccountBalances/EmptyAccountBalances";

import type { ViewMode } from "../useViewPreference";
import type { AddAccountMode } from "../../../../components/settings/linked_accounts/types";
import type { AccountClassType } from "./types";

type AccountsListProps = {
  accounts: AccountClassType[];
  view: ViewMode;
  isEditing?: boolean;
  isHidden?: boolean;
  useExistingListView?: boolean;
  onVerify?: (account: AccountClassType) => void;
  onTriggerInstantVerification?: (mode: AddAccountMode) => void;
};

const AccountsList = ({
  accounts,
  view,
  isEditing = false,
  isHidden = false,
  useExistingListView = false,
  onVerify,
  onTriggerInstantVerification,
}: AccountsListProps) => {
  const { m: isMediumViewport } = useBreakpoints();
  const isSmall = !isMediumViewport;

  if (view === "list" && useExistingListView) {
    return <AccountBalances />;
  }
  if (accounts.length === 0) {
    return (
      <div className="padding--x--l">
        <EmptyAccountBalances />
      </div>
    );
  }
  return view === "card" ? (
    <div className={styles.cardGrid}>
      {accounts.map((account) => (
        <AccountCard
          key={account.id}
          account={account}
          isEditing={isEditing}
          isHidden={isHidden}
          onVerify={onVerify}
          onTriggerInstantVerification={onTriggerInstantVerification}
        />
      ))}
    </div>
  ) : (
    <div className={styles.listContainer}>
      {accounts.map((account) => (
        <AccountListRow
          key={account.id}
          account={account}
          isEditing={isEditing}
          isHidden={isHidden}
          isSmall={isSmall}
          onVerify={onVerify}
          onTriggerInstantVerification={onTriggerInstantVerification}
        />
      ))}
    </div>
  );
};

export default AccountsList;
